import { useEffect, useRef } from "react";
import type { ChangeKind } from "./ChangeSymbol";

export type StatusEntry = {
  id: string;
  text: string;
  kind: ChangeKind | "info";
};

type StatusFeedProps = {
  entries: StatusEntry[];
};

export function StatusFeed({ entries }: StatusFeedProps) {
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!ref.current) return;
    ref.current.scrollTop = ref.current.scrollHeight;
  }, [entries.length]);
  return (
    <div ref={ref} className="af-feed">
      {entries.map((s) => (
        <div key={s.id} className="af-feed-row">
          <span className={`af-feed-dot af-feed-dot-${s.kind}`} />
          <span className="mono af-feed-text">{s.text}</span>
        </div>
      ))}
    </div>
  );
}
